<!-- variant 'wireframe': business Employees card (gigsumo-inapp-company-page-Opti.html
     .member-card). Opt-in via [variant]; the default card below is untouched. -->
<div class="uc-wf-card" *ngIf="ready && variant === 'wireframe'">
  <div class="uc-wf-body" [class.uc-wf-body--no-stats]="!showStats">
    <div class="uc-wf-av" (click)="navigateUserProfile(user)">
      <img *ngIf="user.photo" [src]="user.photo" alt="" (load)="loaded = true" [hidden]="!loaded">
      <div *ngIf="!user.photo" class="uc-wf-initials"
        [style.background-color]="getColortwo(user?.firstName, user?.lastName)"
        [style.color]="getTextColor(user?.firstName, user?.lastName)">{{ getInitialstwo(user?.firstName, user?.lastName) }}</div>
    </div>
    <div class="uc-wf-main">
      <div class="uc-wf-name-row">
        <a class="uc-wf-name" [title]="user.firstName + ' ' + user.lastName" (click)="navigateUserProfile(user)">{{user.firstName}} {{user.lastName}}</a>
        <div class="uc-wf-tools">
          <img *ngIf="user.type=='SUPERADMIN' || user.businessUserType == 'SUPERADMIN' || user.isAdmin === true" class="uc-wf-role" title="Owner" src="assets/icon/crown_.PNG" alt="Owner">
          <img *ngIf="user.type=='ADMIN' || user.businessUserType == 'ADMIN'" class="uc-wf-role" title="Admin" src="assets/icon/admin_cogs.PNG" alt="Admin">
          <span *ngIf="selfUser" class="uc-wf-you">{{ lblName }}</span>
          <div *ngIf="wfShowMenu" class="btn-group uc-wf-menu" dropdown placement="bottom right">
            <button type="button" dropdownToggle class="uc-wf-kebab" aria-label="More options">
              <svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
            </button>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right uc-wf-menu-list" role="menu">
              <li *ngFor="let data of dropdownList" role="menuitem">
                <a class="dropdown-item" (click)="onclick(data)">{{ data?.buttonName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="uc-wf-rows">
        <div class="uc-wf-row" *ngIf="user.requestSentTitle || user.title || getUserTypeLabel(user.userType)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
          <span [title]="user.requestSentTitle || user.title || getUserTypeLabel(user.userType)">{{ user.requestSentTitle || user.title || getUserTypeLabel(user.userType) }}</span>
        </div>
        <div class="uc-wf-row" *ngIf="user.requestSentOrganization || user.organisation">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
          <span [title]="user.organisation">{{ user.requestSentOrganization || user.organisation }}</span>
        </div>
        <div class="uc-wf-row" *ngIf="wfLocation">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          <span [title]="wfLocation">{{ wfLocation }}</span>
        </div>
      </div>
      <div class="uc-wf-stats" *ngIf="showStats && showFooter && wfStats">{{ wfStats }}</div>
    </div>
  </div>
  <div class="uc-wf-footer">
    <button type="button" class="uc-wf-foot-btn" (click)="navigateUserProfile(user)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>View profile
    </button>
    <ng-container *ngIf="wfShowPrimary">
      <div class="uc-wf-divider"></div>
      <button type="button" class="uc-wf-foot-btn"
        [class.uc-wf-foot-btn--muted]="primaryButton.buttonName == 'Cancel' || primaryButton.buttonName == 'Cancel Request'"
        (click)="onclick(primaryButton)">
        <svg *ngIf="user.connectionStatus == 'CONNECTED' && primaryButton.buttonName != 'Accept'; else connectIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        <ng-template #connectIcon><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg></ng-template>
        {{ primaryButton.buttonName }}
      </button>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="variant !== 'wireframe'">
<div class="hpanel  contact-panel " [class.uc-std]="standard" style="margin-bottom: 0px!important;" *ngIf="ready">
  <div class="panel-body pd-lt-12 cp jsoh border-radius-top-left-right-6 border-radius-bottom-left-right-0">
    <div class="row">
      <div class="col-sm-4">
        <div *ngIf="user.photo">
          <img class="img-circle" [src]="user.photo" (load)="loaded = true" [hidden]="!loaded">
        </div>
        <div *ngIf="!user.photo">
          <div class="circles" [style.background-color]="getColortwo(user?.firstName, user?.lastName)">
            <div class="circle-text"  [style.color]="getTextColor(user?.firstName, user?.lastName)" style="font-weight: bold; font-size: 16px;">{{ getInitialstwo(user?.firstName, user?.lastName) }}</div>
          </div>
        </div>
      </div>
      <div class="col-sm-8 skdh0">
        <div class="kskls" style="gap: 0.1rem !important;">
          <div *ngIf="!selfUser" style="gap: 0.1rem !important;">
            <ng-container [ngSwitch]="button">
              <ng-container *ngSwitchCase="'PRIMARY'">

             
                    <button type="button" class="btn btn-primary b-5 btn-xs" [ngClass]="{
                        'cancel-request-btn': user.connectionStatus == 'REQUEST_SENT' && user.page && user.page !== 'employeerequest',
                        'accept-request-btn': (user.connectionStatus == 'REQUEST_PENDING' || user.connectionStatus == 'REQUEST_RECEIVED') && user.page && user.page !== 'employeerequest'
                      }" *ngIf="primaryButton && primaryButton.buttonName &&
                               ((!selfUser && user.page == 'connectionList' && hideButton) ||
                               (!selfUser && (user.connectionStatus == 'NOT_CONNECTED' || user.connectionStatus == 'CONNECTED') && hideButton) ||
                               (!selfUser && user.connectionStatus == 'REQUEST_RECEIVED' && hideButton) ||
                               (!selfUser && user.connectionStatus == 'REQUEST_PENDING' && user.requestedBy && user.requestedBy !== businessData?.userId && hideButton) ||
                               (!selfUser && user.page == 'employeerequest' && hideButton))"

                             (click)="onclick(primaryButton)">
                      {{ primaryButton.buttonName }}
                      <ng-icon name="tablerMail" class="jwsk gs-icon-action" *ngIf="user.connectionStatus == 'CONNECTED' && primaryButton.buttonName != 'Accept'"  aria-hidden="true" style="vertical-align: -0.25em !important;"></ng-icon>
                    </button>
                <button
                  *ngIf="primaryButton && primaryButton.buttonName && ulbutton &&
                        (user.connectionStatus=='REQUEST_PENDING' && user.page != 'connectionList' && user.page != 'employeerequest')"
                  type="button" class="btn btn-primary  b-5  btn-xs"
                  (click)="onclick(primaryButton)">{{primaryButton.buttonName}}
                </button>
                <div class="btn-group three_icon_cmon1 hovers" id="the-dropdown" dropdown>

                  <a id="button-animated"
                    *ngIf="dropdownList?.length > 0&&!ulbutton || ( dropdownList?.length > 0 && !selfUser && user.page == 'COMMUNITY' && user.menu == 'memberspage' && (user.connectionStatus != 'NOT_CONNECTED' || user.connectionStatus != 'CONNECTED'))"
                    dropdownToggle class="m-r-10">
                    <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote">
                  </a>
                  <ul id="dropdown-animated" id="the-dropdowns" *dropdownMenu class="dropdown-menu m-l-81" role="menu"
                    aria-labelledby="button-animated">
                    <li *ngFor="let data of dropdownList" role="menuitem" dropdown>
                      <a class="dropdown-item common-font-12 padd" dropdownToggle
                        (click)="onclick(data)">{{data?.buttonName}}</a>
                    </li>
                  </ul>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'SECONDARY'">
                <div class="btn-group" dropdown>
                  <a id="button-animated" *ngIf="dropdownList?.length > 0" dropdownToggle class="m-r-10">
                    <img src="assets/icon/icons8-menu-vertical-32.png" alt="" srcset="" class="Vthree-dote">
                  </a>
                  <ul class="dropdown-menu" *dropdownMenu role="menu" style=" right: 0;left: auto;">
                    <li *ngFor="let data of dropdownList" role="menuitem" aria-expanded="false">
                      <a class="dropdown-item common-font-12" (click)="onclick(data)">{{data?.buttonName}}</a>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div *ngIf="selfUser">
            <div class="fl-rtt mxpl" style="margin-right: 7px;" (click)="navigateUserProfile(user)">
              <span class="label label-info font-normal" style="font-size: 11px;">{{lblName}}</span>
            </div>
          </div>
        </div>



      </div>
      <div class="col-sm-12 mr-lt-10" (click)="navigateUserProfile(user)">
        <div class="row">
          <div class="col-sm-9">
            <h6 data-toggle="tooltip" data-placement="top" title="{{user.firstName}} {{user.lastName}} ">
              <a class="admin-name" (click)="navigateUserProfile(user)">{{user.firstName}} {{user.lastName }} </a>
            </h6>
          </div>
          <div class="col-sm-3" (click)="navigateUserProfile(user)">
            <div class="fl-rtt"
              *ngIf="user.type=='SUPERADMIN' || user.businessUserType == 'SUPERADMIN' || user.isAdmin === true">
              <span><img class="crown" title="Owner" src="assets/icon/crown_.PNG" alt=""></span>
            </div>
            <div class="fl-rtt" *ngIf="user.type=='ADMIN' || user.businessUserType == 'ADMIN'">
              <span><img class="crown" title="Admin" src="assets/icon/admin_cogs.PNG" alt=""></span>
            </div>
          </div>
        </div>

        <div class="talha" (click)="navigateUserProfile(user)">
          <!-- Title line: prefer requestSentTitle, then the profile title.
               When BOTH are null/empty, fall back to the humanized userType
               (e.g. "Bench Recruiter") so the card never shows a blank title. -->
          <p *ngIf="user.requestSentTitle || user.title"
            data-toggle="tooltip" data-placement="top"
            title="{{ user.requestSentTitle || user.title }} " class="ellipse common-font-11">
            {{ user.requestSentTitle || user.title }}</p>
          <p *ngIf="!(user.requestSentTitle || user.title) && getUserTypeLabel(user.userType)"
            data-toggle="tooltip" data-placement="top"
            title="{{ getUserTypeLabel(user.userType) }} " class="ellipse common-font-11">
            {{ getUserTypeLabel(user.userType) }}</p>



          <p *ngIf="user.requestSentOrganization === undefined || user.requestSentOrganization === null || user.requestSentOrganization === ''"
            data-toggle="tooltip" data-placement="top" title="{{user.organisation}} " class="ellipse common-font-11">
            {{user.organisation }}</p>

          <p *ngIf="user.requestSentOrganization !== undefined && user.requestSentOrganization !== null && user.requestSentOrganization !== ''"
            data-toggle="tooltip" data-placement="top" title="{{user.organisation}} " class="ellipse common-font-11">
            {{user.requestSentOrganization }}</p>
        </div>


      </div>
    </div>


  </div>
  <div class="panel-footer contact-footer lahfp border-radius-top-left-right-0" *ngIf="showFooter">
      <div
        *ngIf="(user?.userType === 'RECRUITER' || user?.userType === 'BENCH_RECRUITER' ||user?.userType === 'JOB_SEEKER')">

        <div class="col-md-6 p-0">
          <div class="contact-stat"><span>Connections</span>
            <strong>{{ user.connectionCnt != null && user.connectionCnt != undefined ? user.connectionCnt : '0'
              }}</strong>
          </div>
        </div>

        <div class="col-md-6 p-0">

          <div *ngIf="user?.userType === 'RECRUITER'" class="contact-stat"><span> Jobs</span>
            <strong>{{ user.jobsCount != null && user.jobsCount != undefined ? user.jobsCount : '0' }}</strong>
          </div>

          <div *ngIf="user?.userType === 'BENCH_RECRUITER' ||user?.userType === 'JOB_SEEKER'" class="contact-stat">
            <span> Candidates</span>
            <strong>{{ user.candidatesCount != null && user.candidatesCount != undefined ? user.candidatesCount : '0'
              }}</strong>
          </div>
        </div>
      </div>
      <div class="userCard-item col-sm-12"
        *ngIf="(user?.userType === 'MANAGEMENT_TALENT_ACQUISITION' || user?.userType === 'FREELANCE_RECRUITER')">

        <div class="col-sm-4 p-0">
          <div class="contact-stat"><span>Connections </span>
            <strong>{{ user.connectionCnt != null && user.connectionCnt != undefined ? user.connectionCnt : '0'
              }}</strong>
          </div>
        </div>

        <div class="col-sm-4 p-0">
          <div class="contact-stat"><span> Jobs </span>
            <strong>{{ user.jobsCount != null && user.jobsCount != undefined ? user.jobsCount : '0' }}</strong>
          </div>
        </div>

        <div class="col-sm-4 p-0">
          <div class="contact-stat"><span> Candidates </span>
            <strong>{{ user.candidatesCount != null && user.candidatesCount != undefined ? user.candidatesCount : '0'
              }}</strong>
          </div>
        </div>

      </div>
  </div>
  </div>
</ng-container>
